import * as types from './types'
import pc from '../../pc';

let ls = JSON.parse(localStorage.getItem('logged'))
let d2 = new Date()
if (ls == null || ((((d2.getTime() - (ls.auth_time * 1000))) / 86400000) > 1)) {
  ls = null
  localStorage.removeItem('logged')
}

const getInitialPostalFilters = (d) => {
  const districts = d.map(item => item.district);
  return districts.filter((v,i) => districts.indexOf(v) === i).map(i => { return { name: i, selected: false } });
}

const slugify = (text) => {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '_')           // Replace spaces with -
    .replace(/[^\w-]+/g, '')       // Remove all non-word chars
    .replace(/--+/g, '_')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

const getInitialLocality = (d) => {
  const localities = d.map(item => item.locality_name);
  return localities.filter((v,i) => localities.indexOf(v) === i).map(l => { return {
    key: slugify(l),
    name: l,
    selected: false,
  }});
}

let initialState = {
  giveUpComments: [],
  filter: {
    spending_areas: [
      {key: 'adult_social_care', name: 'Adult Social Care', selected: true},
      {key: 'children_social_care', name: 'Children Social Care', selected: true},
      {key: 'refuse_waste_collection_disposal', name: 'Refuse, Waste Collection and Disposal', selected: true},
      {key: 'education_early_years', name: 'Early Years and Education', selected: true},
      {key: 'culture_leisure_libraries', name: 'Culture, Leisure and Libraries', selected: true},
      {key: 'maintaining_highways_parking', name: 'Maintaining Highways and Parking', selected: true},
      {key: 'maintaining_neighbourhoods', name: 'Maintaining Neighbourhoods', selected: true},
      {key: 'planning_and_development', name: 'Planning & Development', selected: true},
      {key: 'public_health', name: 'Public Health and Housing', selected: true},
      {key: 'business_econ_development', name: 'Business and Economic Development', selected: true},
      {key: 'enforcement_and_regulation', name: 'Enforcement and Regulation', selected: true},
      {key: 'core_business_functions', name: 'Enabling and Business Functions', selected: true}
    ],

    types: [{key: 'low_risk', name: 'Low', selected: false}, {key: 'med_risk', name: 'Med', selected: false}, {key: 'high_risk', name: 'High', selected: false}],
    gender: [{ key: 'm', name: 'Male', selected: false}, { key: 'f', name: 'Female', selected: false}, { key: 'o', name: 'Other', selected: false}, { key: 'n', name: 'Prefer not to Say', selected: false}],
    age: [{ name: 'Under 16', selected: false}, { name: '16-25', selected: false}, { name: '26-40', selected: false}, { name: '41-65', selected: false}, { name: 'Over 65', selected: false}],
    locality: getInitialLocality(pc),
    postal: getInitialPostalFilters(pc),
  },
  fetched: [],
  displayed: { total_spend: 0, council_tax: 0, council_tax_percent: 0, budgets_submitted: 0, low_risk_budgets: 0, high_risk_budgets: 0, spending_areas: { 'older_people_social_care': 0, 'adult_social_care': 0, 'children_social_care': 0, 'education_early_years': 0, 'education_primary': 0, 'maintaining_highways_parking': 0, 'maintaining_neighbourhoods': 0, 'planning_and_development': 0, 'public_health': 0, 'business_econ_development': 0, 'enforcement_and_regulation': 0, 'core_business_functions': 0}, council_1: 0, council_2: 0, council_3: 0, council_4: 0 },
  selected_filters: [],
  auth: { auth_time: ls != null ? ls.auth_time : null, auth_status: ls != null ? true : false, auth_error: false, auth_email: ls != null ? ls.auth_email : null, auth_token: ls != null ? ls.auth_token : null}
}
let clearState = {
  filter: {
    spending_areas:[
      {key: 'adult_social_care', name: 'Adult Social Care', selected: true},
      {key: 'children_social_care', name: 'Children Social Care', selected: true},
      {key: 'refuse_waste_collection_disposal', name: 'Refuse, Waste Collection and Disposal', selected: true},
      {key: 'education_early_years', name: 'Early Years and Education', selected: true},
      {key: 'culture_leisure_libraries', name: 'Culture, Leisure and Libraries', selected: true},
      {key: 'maintaining_highways_parking', name: 'Maintaining Highways and Parking', selected: true},
      {key: 'maintaining_neighbourhoods', name: 'Maintaining Neighbourhoods', selected: true},
      {key: 'planning_and_development', name: 'Planning & Development', selected: true},
      {key: 'public_health', name: 'Public Health and Housing', selected: true},
      {key: 'business_econ_development', name: 'Business and Economic Development', selected: true},
      {key: 'enforcement_and_regulation', name: 'Enforcement and Regulation', selected: true},
      {key: 'core_business_functions', name: 'Enabling and Business Functions', selected: true}
    ],
    types: [{key: 'low_risk', name: 'Low', selected: false}, {key: 'med_risk', name: 'Med', selected: false}, {key: 'high_risk', name: 'High', selected: false}],
    gender: [{ key: 'm', name: 'Male', selected: false}, { key: 'f', name: 'Female', selected: false}, { key: 'o', name: 'Other', selected: false}, { key: 'n', name: 'Prefer not to Say', selected: false}],
    age: [{ name: 'Under 16', selected: false}, { name: '16-25', selected: false}, { name: '26-40', selected: false}, { name: '41-65', selected: false}, { name: 'Over 65', selected: false}],
    locality: getInitialLocality(pc),
    postal: getInitialPostalFilters(pc),
  }
}

const reducer = (state = initialState
, action) => {
  switch (action.type) {
    case types.CHANGE_FILTER:
      return action.payload

    case types.LOGIN_SUCCESS:
      let s = JSON.parse(JSON.stringify(state))
      return Object.assign({}, s, {auth: {auth_email: action.payload.email, auth_time: action.payload.last_login, auth_token: action.payload.access_token, auth_status: true, auth_error: false}})
    case types.LOGIN_FAILURE:
      let s2 = JSON.parse(JSON.stringify(state))
      return Object.assign({}, s2, {auth: {auth_error: true}})
    case types.LOGOUT:
      let s3 = JSON.parse(JSON.stringify(state))
      return Object.assign({}, s3, {auth: {auth_email: null, auth_time: null, auth_token: null, auth_status: false, auth_error: false}})
    case types.CLEAR:
      return Object.assign({}, state, clearState)
    case types.QUERY:
      return Object.assign({}, state, {fetched: action.payload})
    case types.SET_GIVE_UP_COMMENTS:
      return {
        ...state,
        giveUpComments: action.payload,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/reducks/reports/reducers.js